import { render } from "./InventoryQueueModal.vue?vue&type=template&id=4f42e434&scoped=true"
import script from "./InventoryQueueModal.vue?vue&type=script&lang=js"
export * from "./InventoryQueueModal.vue?vue&type=script&lang=js"

import "./InventoryQueueModal.vue?vue&type=style&index=0&id=4f42e434&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f42e434"]])

export default __exports__